export const platformCatalog = {
    admin: {
        key: 'admin',
        label: '管理后台',
        subtitle: '销售、项目、财务与运营协同',
        home: '/admin/dashboard',
        accent: '#0057B7',
        userName: '项目运营中心',
    },
}

export const platformList = Object.values(platformCatalog)

export const platformMenus = {
    // 管理后台菜单统一按业务域和管理职责展开，分组名称和权限码需与后端默认 sys_menus 种子保持一致。
    admin: [{
        index: '/admin/dashboard',
        title: '工作台',
        icon: 'el-icon-s-platform',
        permissionCode: 'admin:dashboard'
    }, {
        index: 'admin-sales-crm',
        title: '销售管理',
        icon: 'el-icon-collection-tag',
        permissionCode: 'admin:sales-crm',
        children: [{
            index: 'admin-crm-lead-management',
            title: '线索管理',
            icon: 'el-icon-collection-tag',
            permissionCode: 'admin:crm-lead-management',
            children: [{
                index: '/admin/leads',
                title: '线索池',
                icon: 'el-icon-collection-tag',
                permissionCode: 'admin:leads'
            }, {
                index: '/admin/my-leads',
                title: '我的线索',
                icon: 'el-icon-user-solid',
                permissionCode: 'admin:my-leads'
            },]
        }, {
            index: 'admin-crm-customer-opportunity',
            title: '客户与商机',
            icon: 'el-icon-s-opportunity',
            permissionCode: 'admin:crm-customer-opportunity',
            children: [{
                index: '/admin/customers',
                title: '客户管理',
                icon: 'el-icon-office-building',
                permissionCode: 'admin:customers'
            }, {
                index: '/admin/opportunities',
                title: '商机管理',
                icon: 'el-icon-s-opportunity',
                permissionCode: 'admin:opportunities'
            },]
        }, {
            index: 'admin-quote-contract',
            title: '报价与合同',
            icon: 'el-icon-document',
            permissionCode: 'admin:quote-contract',
            children: [{
                index: '/admin/quotations',
                title: '报价管理',
                icon: 'el-icon-document-checked',
                permissionCode: 'admin:quotations'
            }, {
                index: '/admin/contracts',
                title: '合同管理',
                icon: 'el-icon-folder-checked',
                permissionCode: 'admin:contracts'
            },]
        },],
    }, {
        index: 'admin-in-sales',
        title: '项目履约',
        icon: 'el-icon-s-management',
        permissionCode: 'admin:in-sales',
        children: [{
            index: 'admin-project-delivery',
            title: '项目交付',
            icon: 'el-icon-s-management',
            permissionCode: 'admin:project-delivery',
            children: [{
                index: '/admin/projects',
                title: '项目管理',
                icon: 'el-icon-s-management',
                permissionCode: 'admin:projects'
            }, {
                index: '/admin/media-assets',
                title: '项目影像',
                icon: 'el-icon-picture-outline',
                permissionCode: 'admin:media-assets'
            }, {
                index: '/admin/acceptance',
                title: '客户验收',
                icon: 'el-icon-s-claim',
                permissionCode: 'admin:acceptance'
            },]
        }, {
            index: 'admin-resource-collaboration',
            title: '合作生态承接',
            icon: 'el-icon-s-operation',
            permissionCode: 'admin:resource-collaboration',
            children: [{
                index: '/admin/project-pool',
                title: '项目池配置',
                icon: 'el-icon-files',
                permissionCode: 'admin:project-pool'
            }, {
                index: '/admin/partner-applications',
                title: '接单审核',
                icon: 'el-icon-s-check',
                permissionCode: 'admin:partner-applications'
            },]
        }, {
            index: 'admin-work-execution',
            title: '作业执行',
            icon: 'el-icon-s-promotion',
            permissionCode: 'admin:work-execution',
            children: [{
                index: '/admin/flight-tasks',
                title: '作业任务',
                icon: 'el-icon-s-promotion',
                permissionCode: 'admin:flight-tasks'
            }, {
                index: '/admin/flight-task-calendar',
                title: '作业日历',
                icon: 'el-icon-date',
                permissionCode: 'admin:flight-tasks'
            }, {
                index: '/admin/flight-pilot-assessments',
                title: '飞手评估',
                icon: 'el-icon-data-analysis',
                permissionCode: 'admin:flight-tasks'
            }, {
                index: '/admin/learning-records',
                title: '学习记录',
                icon: 'el-icon-notebook-2',
                permissionCode: 'admin:learning-records'
            },]
        },],
    }, {
        index: 'admin-finance',
        title: '财务管理',
        icon: 'el-icon-wallet',
        permissionCode: 'admin:finance',
        children: [{
            index: 'admin-payment-management',
            title: '回款管理',
            icon: 'el-icon-wallet',
            permissionCode: 'admin:payment-management',
            children: [{
                index: '/admin/payment-plans',
                title: '回款计划',
                icon: 'el-icon-date',
                permissionCode: 'admin:payment-plans'
            }, {
                index: '/admin/payments',
                title: '回款台账',
                icon: 'el-icon-wallet',
                permissionCode: 'admin:payments'
            },]
        }, {
            index: 'admin-invoice-reconciliation',
            title: '发票与对账',
            icon: 'el-icon-tickets',
            permissionCode: 'admin:invoice-reconciliation',
            children: [{
                index: '/admin/invoices',
                title: '开票管理',
                icon: 'el-icon-tickets',
                permissionCode: 'admin:invoices'
            }, {
                index: '/admin/reconciliation',
                title: '对账报表',
                icon: 'el-icon-document-copy',
                permissionCode: 'admin:reconciliation'
            },]
        },],
    }, {
        index: 'admin-after-sales',
        title: '运营中心',
        icon: 'el-icon-service',
        permissionCode: 'admin:after-sales',
        children: [{
            index: 'admin-customer-service',
            title: '客户服务',
            icon: 'el-icon-service',
            permissionCode: 'admin:customer-service',
            children: [{
                index: '/admin/feedback-tickets',
                title: '问题反馈',
                icon: 'el-icon-service',
                permissionCode: 'admin:feedback-tickets'
            },]
        }, {
            index: 'admin-notice-report',
            title: '通知与报表',
            icon: 'el-icon-bell',
            permissionCode: 'admin:notice-report',
            children: [{
                index: '/admin/notice-templates',
                title: '通知模板',
                icon: 'el-icon-message',
                permissionCode: 'admin:notice-templates'
            }, {
                index: '/admin/notice-logs',
                title: '发送日志',
                icon: 'el-icon-chat-line-square',
                permissionCode: 'admin:notice-logs'
            }, {
                index: '/admin/work-reports',
                title: '工作汇总',
                icon: 'el-icon-notebook-2',
                permissionCode: 'admin:work-reports'
            }, {
                index: '/admin/report-exports',
                title: '报表导出',
                icon: 'el-icon-download',
                permissionCode: 'admin:report-exports'
            },]
        }, {
            index: 'admin-brand-website',
            title: '内容运营',
            icon: 'el-icon-s-home',
            permissionCode: 'admin:brand-website',
            children: [{
                index: '/admin/case-library',
                title: '官网内容',
                icon: 'el-icon-picture',
                permissionCode: 'admin:case-library'
            },]
        },],
    }, {
        index: 'admin-base-data',
        title: '业务配置',
        icon: 'el-icon-s-data',
        permissionCode: 'admin:base-data',
        children: [{
            index: 'admin-resource-master',
            title: '合作生态与成员',
            icon: 'el-icon-s-custom',
            permissionCode: 'admin:resource-master',
            children: [{
                index: '/admin/partners',
                title: '合作生态档案',
                icon: 'el-icon-s-custom',
                permissionCode: 'admin:partners'
            }, {
                index: '/admin/flight-pilots',
                title: '合作生态成员',
                icon: 'el-icon-user',
                permissionCode: 'admin:flight-pilots'
            },]
        }, {
            index: 'admin-business-base',
            title: '产品与资源',
            icon: 'el-icon-s-operation',
            permissionCode: 'admin:business-base',
            children: [{
                index: '/admin/products',
                title: '产品与服务',
                icon: 'el-icon-goods',
                permissionCode: 'admin:products'
            }, {
                index: '/admin/system/resource-types',
                title: '资源项配置',
                icon: 'el-icon-s-operation',
                permissionCode: 'admin:system-resource-types'
            },]
        }, {
            index: 'admin-work-base',
            title: '作业配置',
            icon: 'el-icon-connection',
            permissionCode: 'admin:work-base',
            children: [{
                index: '/admin/operation-standards',
                title: '作业类型配置',
                icon: 'el-icon-reading',
                permissionCode: 'admin:operation-standards'
            }, {
                index: '/admin/operation-standard-bundles',
                title: '规范资料库',
                icon: 'el-icon-notebook-2',
                permissionCode: 'admin:operation-standard-bundles'
            }, {
                index: '/admin/system/flight-task-milestone-templates',
                title: '任务里程碑模板',
                icon: 'el-icon-connection',
                permissionCode: 'admin:system-flight-task-milestones'
            },]
        },],
    }, {
        index: 'admin-system-management',
        title: '系统管理',
        icon: 'el-icon-setting',
        permissionCode: 'admin:system-management',
        children: [{
            index: 'admin-permission-system',
            title: '账号与权限',
            icon: 'el-icon-lock',
            permissionCode: 'admin:permission-system',
            children: [{
                index: '/admin/system/accounts',
                title: '成员与账号',
                icon: 'el-icon-user',
                permissionCode: 'admin:system-accounts'
            }, {
                index: '/admin/system/miniapp-users',
                title: '小程序用户',
                icon: 'el-icon-mobile-phone',
                permissionCode: 'admin:miniapp-users'
            }, {
                index: '/admin/system/roles',
                title: '角色权限',
                icon: 'el-icon-lock',
                permissionCode: 'admin:system-roles'
            }, {
                index: '/admin/system/menus',
                title: '菜单管理',
                icon: 'el-icon-menu',
                permissionCode: 'admin:system-menus'
            },]
        }, {
            index: 'admin-system-configuration',
            title: '系统配置',
            icon: 'el-icon-setting',
            permissionCode: 'admin:system-configuration',
            children: [{
                index: '/admin/system/dictionaries',
                title: '业务字典',
                icon: 'el-icon-collection',
                permissionCode: 'admin:system-dictionaries'
            }, {
                index: '/admin/system/config',
                title: '系统配置',
                icon: 'el-icon-setting',
                permissionCode: 'admin:system-config'
            }, {
                index: '/admin/operation-logs',
                title: '操作日志',
                icon: 'el-icon-document',
                permissionCode: 'admin:operation-logs'
            }, {
                index: '/admin/system/environment',
                title: '运行环境',
                icon: 'el-icon-monitor',
                permissionCode: 'admin:system-environment'
            },]
        },],
    },],
}
